module.exports = __webpack_public_path__ + "static/img/news1-cover.7841127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news1-cover.jpg
// module id = 0biy
// module chunks = 0